export const olivePalette = {
  background: {
    'level-1': 'hsl(110, 50%, 98.8%)',
    'level-2': 'hsl(120, 16.7%, 97.6%)',
    'level-3': 'hsl(119, 10.1%, 95.2%)',
    card: 'hsl(118, 8.4%, 93%)'
  },
  text: {
    title: 'hsl(110, 3.2%, 42.9%)',
    subtitle: 'hsl(111, 2.8%, 51.7%)',
    'title-hover': 'hsl(110, 3.5%, 55.5%)'
  },
  primary: {
    light: 'hsl(110, 5.9%, 85.4%)',
    DEFAULT: 'hsl(110, 5.2%, 77.3%)',
    dark: 'hsl(110, 3.5%, 55.5%)',
    50: 'hsl(110, 50%, 98.8%)',
    100: 'hsl(120, 16.7%, 97.6%)',
    200: 'hsl(119, 10.1%, 95.2%)',
    300: 'hsl(118, 8.4%, 93%)',
    400: 'hsl(117, 7.1%, 90.8%)',
    500: 'hsl(115, 6.4%, 88.5%)',
    600: 'hsl(114, 5.9%, 85.4%)',
    700: 'hsl(110, 5.2%, 77.3%)',
    800: 'hsl(110, 3.5%, 55.5%)',
    900: 'hsl(111, 2.8%, 51.7%)'
  },
  secondary: {
    light: 'hsl(110, 6%, 24.5%)',
    DEFAULT: 'hsl(110, 5.5%, 31.8%)',
    dark: 'hsl(110, 5%, 55.5%)'
  },
  accent: {
    // semantic colors
    DEFAULT: 'hsl(0,0%,100%)',
    info: 'hsl(206, 100%, 50%)',
    success: 'hsl(142, 76%, 36%)',
    error: 'hsl(0, 84%, 60%)',
    warning: 'hsl(30, 100%, 50%)'
  }
}
